
import * as Sentry from '@sentry/browser';

function closeAlert(){
  elem.style.display = "none";
}

let elem = document.querySelector('.alert.dismissible');

if(elem){
  let closeIcon = "<span class='alert__close'>x</span>";
  elem.innerHTML = elem.innerHTML + closeIcon;

  document.querySelector('.alert__close').addEventListener("click", closeAlert, false);
}

(function(){
  // $('.analysis_parameters_form').submit(submit_analysis_parameters_form);

  var menu = $(".menu");

  function setup(){
    menuShow();
    modalMenu();
    setupSentryBrowserIntegration();
    setupBtnOrderColumns();
    revealPassword();
  }

  function setupSentryBrowserIntegration(){
    // Initialize Sentry to send metrics about the web vitals (first contentful paint, largest contentful paint, etc.)
    if (window.settings && window.settings.send_logs) {
      Sentry.init({
        dsn: 'https://4e7d4cf592ff4acbb1cd8acc38706597@o1159022.ingest.sentry.io/6242589',
        integrations: [Sentry.browserTracingIntegration({enableInp: true}), Sentry.browserProfilingIntegration()],
        tracesSampleRate: window.settings.trace_sampler_rate,
        release: window.settings.app_version,
        environment: window.settings.logs_env_name,
      });
    }
  }

  function modalMenu(){
    $(".modal__link").on('click', function(event){
      event.preventDefault();
      let anchor = $(this).attr('href');

      // Get the modal container
      let modal = $(this).closest(".modal");

      modal.find(".modal__item").removeClass("modal__item--current");
      $(this).parent().addClass("modal__item--current");

      modal.find(".flow__part").removeClass("flow__part--visible");
      $(anchor).addClass("flow__part--visible");
    });
  }


  function menuShow(){
    $(".menu__action").on('click', function(event) {

      event.preventDefault();
      menu.toggleClass("menu--hidden");
      $(".menu__action").toggleClass("action--hide");

    });
  }

  function setupBtnOrderColumns(){
    $(".button--order-column").on('click', function(event){
      event.preventDefault();
      // Set the value of the order input
      let value = $(this).data("value");
      let input = $("#order_input");
      input.val(value);

      // Submit the form
      let form = $("#" + $(this).data("form"));
      form.trigger("submit");
    });
  }

  function revealPassword(){
    $('.reveal_eye').on('click', function(event){
      let password_field = event.target.parentElement.querySelector("[id*='password']");
      if (password_field.type == 'password') {
        password_field.setAttribute('type', 'text');
        event.target.src = "/static/img/icons/icon--eye-off.svg";
      }
      else {
        password_field.setAttribute('type', 'password');
        event.target.src = "/static/img/icons/icon--eye-black.svg";
      }
    });
  }


  setup();
})();

// function submit_analysis_parameters_form() {
//   var isValid = false;
//   $.ajax({
//       data: $(this).serialize(), // get the form data
//       type: $(this).attr('method'),
//       url: "en/analysis/save_parameters",
//       // on success
//       success: function (response) {
//           alert(response.result)
//           isValid = true;
//       },
//       // on error
//       error: function (response) {
//           // alert the error if any error occured
//           alert(response.responseJSON.errors);
//           console.log(response.responseJSON.errors)
//       }
//   });
//   if (!isValid) {
//       event.preventDefault();
//   }
// }
